export const addMainAds = (content: string, adId: string, distance: number, keywords: string) => {
  const parser = new DOMParser();

  const doc = parser.parseFromString(content, 'text/html');

  const paragraphs = doc.querySelectorAll('p');

  paragraphs.forEach((paragraph, index) => {
    if (index > 0 && index % distance === 0) {
      const broadStreet = doc.createElement('broadstreet-zone');
      broadStreet.setAttribute('zone-id', adId);
      broadStreet.setAttribute('keywords', keywords);
      paragraph.parentNode?.insertBefore(broadStreet, paragraph);
    }
  });

  return doc.documentElement.innerHTML;
};
